export enum SortingConfiguration {
    Alphabetically = 0,
    ByOrderId = 1
}